<template>
  <div class="button_container">
    <el-button size="small" @click="handleEmit('cancel')"> 取消 </el-button>
    <el-button :loading="oLoading.submitLoading" @click="handleEmit('addResult')" type="primary" size="small" v-show="!dingTalkShow">
      提交审批
    </el-button>
    <el-button  :loading="oLoading.submitLoading" @click="handleEmit('dingTalk')" type="primary" size="small" v-show="dingTalkShow">提交钉钉审批</el-button>
    <!-- 新增 slot 插槽满足后续添加需求 -->
    <template>
      <slot name="addSlot"></slot>
    </template>
  </div>
</template>

<script>
export default {
  name: 'CollectionRecordAddBottom',
  data() {
    return {}
  },
  props: {
    dingTalkShow: {
      type: Boolean,
      default: false,
    },
    oLoading: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    handleEmit(type, value) {
      this.$emit(type, value)
    },
  },
}
</script>

<style lang="scss" scoped>
.button_container {
  margin-top: 16px;
  display: flex;
  justify-content: space-evenly;
}
</style>
